import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query VerifySSOEmail($email: String!) {
    verifySsoEmail(email: $email) {
      valid
    }
  }
`;

export const verifySSOEmail = (email) =>
  executeGqlQuery({
    query: QUERY,
    variables: { email },
  }).then(({ data }) => getSingleProp(data));
